<template>
  <div class="form-container">
    <b-button
      v-on:click="clickOpenSignUpModal"
      size="md"
      variant="accent"
      class="btn-sign-up-form btn-modal button-shadow"
    >
      {{ text }}
    </b-button>
  </div>
</template>

<script>
import router from "@/router";
import { mapGetters } from "vuex";
import { bus } from "@/main";

export default {
  props: {
    text: {
      type: String,
      required: false,
      default: "Claim your username",
    },
  },

  computed: {
    ...mapGetters(["currentUser"]),
  },

  methods: {
    clickOpenSignUpModal() {
      if (this.currentUser) {
        router.push({ name: "DiscoverCapsules" });
      } else {
        bus.$emit("openSignUpModal");
      }
    },

    triggerPlayVideo(event) {
      window.location = event.target.href;
      bus.$emit("playVideo");
    },
  },
};
</script>

<style lang="scss">
@import "~@/styles/_colour-palette.scss";

.button-shadow {
  position: relative;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    mix-blend-mode: multiply;
    transition: box-shadow 0.15s ease;
  }

  &:hover {
    &::before {
      box-shadow: 0 8px 24px rgba($primary-blue, 0.25);
    }
  }
}

.btn-sign-up-form {
  padding: 15px;
  border-radius: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/landing/FormHorizontal.vue